import React, { Component } from "react";
import DropDown from "../../../common/dropDown";
import Modal from "../../../common/Modal";

export default class AddAccountModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      accountNumber: "",
      registrationType: "",
      isSubmitting: false,
    };
  }

  // Common registration types - can be fetched from API later
  registrationTypes = [
    "Individual",
    "Joint Tenants",
    "Tenants in Common",
    "Traditional IRA",
    "Roth IRA",
    "SEP IRA",
    "SIMPLE IRA",
    "Rollover IRA",
    "Inherited IRA",
    "401(k)",
    "403(b)",
    "Trust",
    "Revocable Trust",
    "Irrevocable Trust",
    "Custodial (UTMA/UGMA)",
    "Corporate",
    "Partnership",
    "LLC",
    "Sole Proprietorship",
    "Non-Profit/501(c)(3)",
    "Pension",
    "Profit Sharing",
    "Estate",
    "TOD (Transfer on Death)",
  ];

  handleSubmit = () => {
    const { accountNumber, registrationType } = this.state;
    const { onConfirm, onClose } = this.props;

    if (!accountNumber.trim() || !registrationType) {
      alert("Please fill in all fields");
      return;
    }

    this.setState({ isSubmitting: true });
    onConfirm(accountNumber.trim(), registrationType);
    this.setState({ isSubmitting: false });
    onClose();
  };

  render() {
    const { onClose, clientName, show } = this.props;
    const { accountNumber, registrationType, isSubmitting } = this.state;

    return (
      <Modal show={show} onClose={onClose}>
        <div className="modal-header bg-success text-white">
          <h5 className="modal-title">Add Account</h5>
          <button
            type="button"
            className="btn-close btn-close-white"
            onClick={onClose}
            aria-label="Close"
          ></button>
        </div>
        <div className="modal-body">
          <p className="text-muted small mb-3">
            Adding account for client: <strong>{clientName}</strong>
          </p>

          <div className="mb-3">
            <label className="form-label">Account Number</label>
            <input
              type="text"
              className="form-control"
              placeholder="Enter account number"
              value={accountNumber}
              onChange={(e) => this.setState({ accountNumber: e.target.value })}
            />
            <div className="form-text">
              Account numbers will be masked in the display for security.
            </div>
          </div>

          <div className="mb-3">
            <label className="form-label">Registration Type</label>
            <DropDown
              title={registrationType || "Select Registration Type"}
              items={this.registrationTypes}
              textProperty={""}
              valueProperty={""}
              selectedItem={registrationType}
              onItemSelect={(e) => this.setState({ registrationType: e })}
            />
          </div>

          <div className="alert alert-info small">
            <strong>Note:</strong> This will send a request to compliance to add
            this account. The account will not appear until the request is
            processed.
          </div>
        </div>
        <div className="modal-footer">
          <button type="button" className="btn btn-secondary" onClick={onClose}>
            Cancel
          </button>
          <button
            type="button"
            className="btn btn-success"
            onClick={this.handleSubmit}
            disabled={isSubmitting || !accountNumber || !registrationType}
          >
            {isSubmitting ? (
              <span
                className="spinner-border spinner-border-sm me-1"
                role="status"
              ></span>
            ) : null}
            Request Add Account
          </button>
        </div>
      </Modal>
    );
  }
}
